function isOutOfViewport(elem) {
  var bounding = elem.get(0).getBoundingClientRect();

  // Check if it's out of the viewport on each side
  var out = {};
  out.top = bounding.top < 0;
  // out.left = bounding.left < 0;
  out.left = { out: bounding.left < 0, amount: bounding.left };
  out.bottom =
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight);
  //out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.right = {
    out:
      bounding.right >
      (window.innerWidth || document.documentElement.clientWidth),
    amount: bounding.right - document.documentElement.clientWidth
  };
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;

  return out;
}

function trapFocus(e, modalId) {
  const isTabPressed = e.key === `Tab` || e.keyCode === 9;

  /**
   * If a key other than tab is pressed, ignore.
   */
  if (!isTabPressed) {
    return;
  }

  /**
   * Get the targeted modal.
   */
  const modal = document.getElementById(modalId);

  /**
   * Set what type of elements should be able to receive focus.
   */
  const focusableElements = `button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])`;

  /**
   * Get all focusable elements in the modal.
   */
  const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
  const focusableContent = modal.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      /**
       * If tabbing backward (shift-tab) and we're currently on the first element, focus on the last element.
       */
      lastFocusableElement.focus();
      e.preventDefault();
    }
  } else if(!Array.from(focusableContent).includes(document.activeElement)) {
    firstFocusableElement.focus();
    e.preventDefault();
  } else if (document.activeElement === lastFocusableElement) {

    $jq3(".share-popup-container").removeClass("show-container");
    document.removeEventListener(`keydown`, initTrapFocus);
    window.lastActiveFocus.focus();
    e.preventDefault();
  }
}

function initTrapFocus(e) {
  return trapFocus(e, `share-popup`);
}

export function share() {
  var shareEvent;
  var open = false;

  // Show share container
  $jq3(window).click(function(e) {
    if ($jq3(".share-popup-container").hasClass("show-container") && open) {
      e.stopPropagation();
      $jq3(".share-popup-container").removeClass("show-container");
      document.removeEventListener(`keydown`, initTrapFocus);
      window.lastActiveFocus.focus();
    }
  });

  $jq3(".share-button").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();

    window.lastActiveFocus = e.target;

    document.addEventListener(`keydown`, initTrapFocus);

    // var getUrl = window.location;
    // var baseUrl = getUrl.protocol + "//" + getUrl.host;

    const linkToShare = $jq3(this).attr("data-link");

    if (linkToShare.indexOf("undefined") != -1) {
      return;
    }

    $jq3(".share-popup-container").addClass("show-container");
    open = true;

    const offsetTop = $jq3(this).offset().top;
    const outerHeight = $jq3(this).outerHeight();
    const offsetLeft = $jq3(this).offset().left;

    $jq3(".share-popup-container").css({
      top: offsetTop + outerHeight + 10 - 70 + "px",
      left: offsetLeft + "px"
    });

    const isOut = isOutOfViewport($jq3(".share-popup-container"));

    if (isOut.left.out === true) {
      $jq3(".share-popup-container").css(
        "left",
        offsetLeft - isOut.left.amount + 5 + "px"
      );
    }

    if (isOut.right.out === true) {
      $jq3(".share-popup-container").css(
        "left",
        offsetLeft - isOut.right.amount - 5 + "px"
      );
    }

    $jq3(".facebook").on("click", function(e) {
      e.preventDefault();
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + linkToShare,
        "_blank"
      );
    });

    $jq3(".twitter").on("click", function(e) {
      e.preventDefault();
      window.open("https://twitter.com/home?status=" + linkToShare, "_blank");
    });

    $jq3(".pinterest").on("click", function(e) {
      e.preventDefault();
      window.open(
        "https://pinterest.com/pin/create/button/?url=" +
          linkToShare +
          "&media=&description=",
        "_blank"
      );
    });

    $jq3(".linkedin").on("click", function(e) {
      e.preventDefault();
      window.open(
        "https://www.linkedin.com/shareArticle?mini=true&url=" +
          linkToShare +
          "&title=&summary=&source=",
        "_blank"
      );
    });

    $jq3(".xing").on("click", function(e) {
      e.preventDefault();
      window.open(
        "https://www.xing.com/spi/shares/new?url=" + linkToShare,
        "_blank"
      );
    });

    $jq3(".whatsapp").on("click", function(e) {
      e.preventDefault();
      window.open("whatsapp://send?text=" + linkToShare, "_blank");
    });

    $jq3(".email").on("click", function(e) {
      e.preventDefault();
      window.open("mailto:?&subject=&body=" + linkToShare, "_blank");
    });
  });
}
